import { useStyletron } from "baseui";
import { startEndDateFromTimeRange } from "../../Portfolio/PortfolioEnergyChart/utils";
import { SlEnergy } from "react-icons/sl";
import { FormattedMessage } from "react-intl";
import { TimeRange } from "../../Portfolio/PortfolioEnergyChart/types";
import {  OperatorPanelWrapperFullSize } from "../../../components/Layout";
import { LabelMedium } from "baseui/typography";
import Heatmap from "./Heatmap";
import { useGetBuilding } from "../../../../hooks/useGetBuilding";


export const OperatorPanel = (props: any) => {
    const [css, theme] = useStyletron();
    const range = props.timeRange ?? TimeRange.YearToDate;
    const { item: building } = useGetBuilding(props.id,props.resourceGroupId)
    
    return (
        <OperatorPanelWrapperFullSize icon={<SlEnergy size='100%' color={theme.colors.backgroundPrimary}></SlEnergy>}  {...props} >
            <LabelMedium>
             <FormattedMessage id={TimeRange[range]} defaultMessage={TimeRange[range]} /> | kW
             </LabelMedium>
             <Heatmap timeRange={range} {...building} />
        </OperatorPanelWrapperFullSize>
    )
}
